import { render, staticRenderFns } from "./KeyValTable.vue?vue&type=template&id=ceb0e26c"
import script from "./KeyValTable.vue?vue&type=script&lang=js"
export * from "./KeyValTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports